function removeNull(array, key) {
  return array.filter((x) => x !== key);
}
export default removeNull;
